/**
 * Format the laravel pagination url to retreive next paginated results
 *
 * @param {String} url The laravel pagination url to format
 */
// eslint-disable-next-line
export const formatNextPageUrl = url => (url ? url.replace(/\?page=([^&]+)/, '/?page=$1') : null);
